import { QuestionModel } from '@/survey/logic';
import { GraphicSelectModel } from '../QuestionView';

export type LastPageButtonProps = {
  text?: string | null;
  url?: string | null;
};

export class LastPageModel extends QuestionModel {
  get showSalute() {
    // Решение о салюте принимаем только на основе ответа на первый встреченный вопрос со звездами.
    const q = this.survey.questionHistory.find((questionModel) => questionModel instanceof GraphicSelectModel);
    if (!q) {
      return false;
    }
    const selectedStarNumber = q.selectedAnswers[0]?.answer_number;
    return !!selectedStarNumber && selectedStarNumber > 3;
  }

  get buttonProps() {
    const props: LastPageButtonProps = {};

    if (!this.suitableRelation) {
      return props;
    }

    if (this.suitableRelation.is_default) {
      props.text = this.survey.defaultLastPageButtonProps.text;
      props.url = this.survey.defaultLastPageButtonProps.url;
    } else {
      props.text = this.question.form_end_points.at(0)?.button_name;
      props.url = this.question.form_end_points.at(0)?.end_point_url;
    }

    return props;
  }
}
